<template>
  <div>
    <v-dialog v-model="editWorktimeDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ editDialogLabel }}打刻修正
          <v-spacer></v-spacer>
          <v-btn icon @click="editWorktimeDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <input-hour-min v-model="editUnixtime" />
          <v-layout row wrap>
            <v-flex md12>
              <v-textarea
                label="修正理由"
                v-model="editReasons"
                :rows="2"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-alert
            :value="editWorktimeErrors.length > 0"
            color="error"
            outline
            >{{ editWorktimeErrors }}</v-alert
          >
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue"
            class="white--text"
            @click="editWorktimeDialog = false"
            >キャンセル</v-btn
          >
          <v-btn color="blue" class="white--text" @click="saveWorktime"
            >保存</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="card--flex-toolbar">
      <v-toolbar fixed prominent>
        <v-toolbar-title class="headline black--text">{{
          dialogTitle
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="padding-top: 64px">
        <v-container grid-list-md>
          <h1>勤怠</h1>
          <h2>休暇</h2>
          <v-layout row wrap>
            <v-flex md5>
              <v-select
                v-model="value.holidayType"
                label="休暇申請"
                :items="dayTypes"
                attach
              ></v-select>
            </v-flex>
          </v-layout>
          <div v-if="value.version > 1" style="margin-bottom: 1em">
            <h2>勤務一覧</h2>
            <v-layout row wrap>
              <working-hours-table
                :hours="value.working_hours ? value.working_hours : []"
                @updateItems="updateWorkingHours"
              />
            </v-layout>
          </div>
          <v-layout row wrap>
            <v-flex md3>
              <h2>始業</h2>
            </v-flex>
            <v-flex md3>
              <h2>終業</h2>
            </v-flex>

            <v-flex md3>
              <h2>実働</h2>
            </v-flex>
            <v-flex md3>
              <h2>深夜</h2>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex md2>
              <input-time v-model="value.start" :readonly="true" />
            </v-flex>
            <v-flex md1>
              <!-- <v-btn icon @click="editWorktime('start')">
                <v-icon>edit</v-icon>
              </v-btn> -->
            </v-flex>
            <v-flex md2>
              <input-time v-model="value.end" :readonly="true" />
            </v-flex>
            <v-flex md2 offset-md1>
              <input-time
                :isBy10Minutes="true"
                v-model="working"
                :readonly="true"
              />
            </v-flex>
            <v-flex md2 offset-md1>
              <input-time
                :isBy10Minutes="true"
                v-model="lateNight"
                :readonly="true"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md3>
              <div class="new-line" v-if="value.reasonsForEditStart">
                修正理由：{{ value.reasonsForEditStart }}
              </div>
            </v-flex>
            <v-flex md3>
              <div class="new-line" v-if="value.reasonsForEditEnd">
                修正理由：{{ value.reasonsForEditEnd }}
              </div>
            </v-flex>

          </v-layout>
          <v-layout row wrap style="margin-top: 1em">
            <v-flex md3>
              <h2>休憩（出社）</h2>
            </v-flex>
            <v-flex md3>
              <h2>休憩（在宅）</h2>
            </v-flex>
            <v-flex md3>
              <h2>その他休憩</h2>
            </v-flex>
            <v-flex md3>
              <h2>左記のうち深夜時間</h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md2>
              <input-time :isBy10Minutes="true" v-model="value.lunch" />
            </v-flex>
            <v-flex md2 offset-md1>
              <input-time :isBy10Minutes="true" v-model="value.break" />
            </v-flex>

            <v-flex md2 offset-md1>
              <input-time
                :isBy10Minutes="true"
                v-model="value.total_nonworking_hours"
                :readonly="true"
              />
            </v-flex>
            <v-flex md2 offset-md1>
              <input-time :isBy10Minutes="true" v-model="value.break_late_night" />
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            style="margin-top: 1em"
            v-if="shoudCountingOfficeWorkingHours"
          >
            <v-flex md3 >
              <h2>出社実働</h2>
            </v-flex>
            <v-flex md3>
              <h2>在宅実働</h2>
            </v-flex>
            <v-flex md3>
              <h2>在宅勤務時間</h2>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="shoudCountingOfficeWorkingHours">

            <v-flex md2>
              <input-time
                :isBy10Minutes="true"
                v-model="actualOfficeWorkingHours"
                :readonly="true"
              />
            </v-flex>
            <v-flex md2 offset-md1>
              <input-time
                :isBy10Minutes="true"
                v-model="actualHomeWorkingHours"
                :readonly="true"
              />
            </v-flex>
            <v-flex md2 offset-md1>
              <input-time
                :isBy10Minutes="true"
                v-model="value.total_home_working_hours"
                :readonly="true"
                v-if="value.total_home_working_hours"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <h1>原価</h1>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="toHelpSite" >help_box</v-icon>
                </template>
                <span>原価の振り分けに迷ったらNotePMの部門コード一覧を参照、もしくは所属チーム内にて確認ください</span>
            </v-tooltip>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6>
              <table>
                <colgroup>
                  <col style="width: 20%" />
                  <col style="width: 45%" />
                  <col style="width: 35%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>操作</th>
                    <th>クライアント名</th>
                    <th>時間</th>
                  </tr>
                </thead>
                <tr v-for="(cost, i) in costs" :key="cost.client_name">
                  <td class="delete-cell">
                    <v-btn
                      small
                      @click="rowUp(i)"
                      icon
                      class="action-btn"
                      :disabled="i == 0"
                    >
                      <v-icon>arrow_upward</v-icon>
                    </v-btn>
                    <v-btn
                      small
                      @click="rowDown(i)"
                      icon
                      class="action-btn"
                      :disabled="i == costs.length - 1"
                    >
                      <v-icon>arrow_downward</v-icon>
                    </v-btn>
                    <v-btn
                      small
                      @click="deleteCost(cost)"
                      icon
                      class="action-btn"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </td>
                  <td>{{ cost.client_name }}</td>
                  <td>
                    <input-time :isBy10Minutes="true" v-model="cost.time" />
                  </td>
                </tr>
              </table>
            </v-flex>

            <v-flex md4>
              <v-autocomplete
                label="クライアントの追加"
                :hint="
                  isSettingLoaded
                    ? 'クライアント番号や名前を入れて絞り込んでください。'
                    : 'クライアントリスト読み込み中です。少々お待ちください。'
                "
                persistent-hint
                :error-messages="costClientError"
                v-model="costClient"
                :items="clients"
                item-text="keyword"
                item-value="id"
                :disabled="!isSettingLoaded"
              />
            </v-flex>
            <v-flex md2>
              <v-btn color="blue" class="white--text" @click="addCost"
                >追加</v-btn
              >
            </v-flex>
          </v-layout>
          <v-flex md4 offset-md2>
            <table>
              <tr>
                <th>実働時間-原価時間</th>
                <th>原価時間合計</th>
              </tr>
              <tr>
                <td>
                  <input-time
                    :isBy10Minutes="true"
                    v-model="diffWorkingAndCosts"
                    readonly
                  />
                </td>
                <td>
                  <input-time
                    :isBy10Minutes="true"
                    v-model="sumOfCosts"
                    readonly
                  />
                </td>
              </tr>
            </table>
          </v-flex>
          <template v-if="owner.commuting_allowance_type == '日額'">
            <h1>通勤費</h1>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2>通勤経路</v-flex>
              <v-flex md4>
                <v-text-field
                  type="text"
                  v-model="value.daily_commuting_route"
                />
              </v-flex>
              <v-flex md1>通勤費</v-flex>
              <v-flex md2>
                <v-text-field
                  type="number"
                  v-model.number="value.daily_commuting_allowance"
                  suffix="円"
                />
              </v-flex>
            </v-layout>
          </template>
          <h1>経費</h1>
          <v-layout row wrap>
            <v-flex md4>
              <v-autocomplete
                v-if="expense"
                label="クライアントの追加"
                hint="クライアント番号や名前を入れて絞り込んでください。"
                persistent-hint
                v-model="expense.client_id"
                :items="clients"
                item-text="keyword"
                item-value="id"
                :readonly="false"
              />
            </v-flex>
            <v-flex md2>
              <v-select
                label="種別"
                :items="expenseType"
                v-model="expense.type"
              />
            </v-flex>
            <v-flex md2>
              <v-text-field
                label="金額"
                v-model.number="expense.price"
                type="number"
              />
            </v-flex>
            <v-flex md4>
              <v-alert
                :value="expenseErros.length > 0"
                color="error"
                outline
                class="multi-line"
                >{{ expenseErros.join("\n") }}</v-alert
              >
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md8>
              <v-text-field label="備考" v-model="expense.note" />
            </v-flex>
            <v-flex md2 offset-md2>
              <v-btn color="blue" class="white--text" @click="addExpense"
                >追加</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md12>
              <table>
                <colgroup>
                  <col style="width: 5%" />
                  <col style="width: 25%" />
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                  <col style="width: 50%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>削除</th>
                    <th>クライアント名</th>
                    <th>種別</th>
                    <th>金額</th>
                    <th>備考</th>
                  </tr>
                </thead>
                <tr v-for="(expense, i) in expenses" :key="i">
                  <td class="delete-cell">
                    <v-btn small @click="deleteExpense(i)" icon>
                      <v-icon>close</v-icon>
                    </v-btn>
                  </td>
                  <td>{{ expense.client_name }}</td>
                  <td>{{ expense.type }}</td>
                  <td>{{ expense.price }}</td>
                  <td>{{ expense.note }}</td>
                </tr>
              </table>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md2 offset-md10>
              <table>
                <tr>
                  <th>経費合計</th>
                </tr>
                <tr>
                  <td>{{ sumOfExpenses }}</td>
                </tr>
              </table>
            </v-flex>
          </v-layout>

          <h1>備考</h1>
          <v-layout row wrap>
            <v-flex sm12 md8>
              <v-textarea
                v-model="value.note"
                label="備考"
                auto-grow
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6>
              <v-alert
                :value="worktimeErrors.length > 0"
                color="error"
                outline
                class="multi-line"
                >{{ worktimeErrors.join("\n") }}</v-alert
              >
              <v-alert
                :value="timecardErrors.length > 0"
                color="error"
                outline
                class="multi-line"
                >{{ timecardErrors.join("\n") }}</v-alert
              >
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" class="white--text" @click="deleteItem">削除</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue" class="white--text" @click="closeDialog"
          >キャンセル</v-btn
        >
        <v-btn color="blue" class="white--text" @click="saveItem(false)"
          >一時保存</v-btn
        >
        <v-btn color="blue" class="white--text" @click="saveItem(true)"
          >保存</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import db from "@/components/firebaseInit";
import InputTime from "@/components/inputTime";
import InputHourMin from "@/components/inputHourMin";
import { mapGetters, mapActions } from "vuex";
import WorkingHoursTable from "@/components/EditTimecard/workingHoursTable";
import Vue from 'vue'

export default {
  components: {
    InputTime,
    InputHourMin,
    WorkingHoursTable,
  },
  props: ["value", "calender", "owner"],
  data: () => ({
    dbRef: db.collection("clients"),
    dbRefUser: db.collection("users"),
    editUnixtime: 0,
    dialog: false,
    dayTypes: [
      "",
      "有休",
      "半休",
      "無給",
      "欠勤",
      "半欠勤",
      "振休",
      "振休(所定休)",
      "振出",
      "所定休",
      "特別有休（M休やV休）",
      "産前休",
      "産後休",
      "育児休",
      "介護休",
      "休職",
      "その他休"
    ],
    costs: [],
    clients: [],
    costClient: "",
    costClientError: "",
    expenses: [],
    expense: {
      client_id: "",
      client_name: "",
      price: 0,
      type: "",
      note: "",
    },
    expenseType: ["その他交通費", "その他"],
    expenseErros: [],
    worktimeErrors: [],
    reasonError: "",
    workstartBackup: 0,
    workendBackup: 0,
    timecardErrors: [],
    isSettingLoaded: false,
    editWorktimeDialog: false,
    editDialogLabel: "",
    editWorktimeErrors: "",
    startOrEnd: "start",
    editReasons: "",
  }),
  created(){
    if(!('break_late_night' in this.value)){
      Vue.set(this.value, 'break_late_night', 0)
    }

  },
  mounted() {
    this.expenses = this.value.expenses ? this.value.expenses : [];

    if (this.value.costs && this.value.costs.length > 0) {
      this.costs = this.value.costs;
    } else {
      this.setCosts();
    }
    this.updateWorkingHours();
    this.isSettingLoaded = false;
    this.loadSettings();
  },
  methods: {
    toHelpSite(){
      window.open('https://pragma.notepm.jp/page/4d1c8728e7#%E9%83%A8%E9%96%80%E3%82%B3%E3%83%BC%E3%83%89%E4%B8%80%E8%A6%A7', '_blank')
    },
    async setCosts() {
      this.changeLoadingState(true);
      const ownerDoc = await this.dbRefUser.doc(this.owner.id).get();
      const owner = ownerDoc.data();

      this.costs = owner.default_costs
        ? owner.default_costs.map((item) => {
            return JSON.parse(JSON.stringify(item));
          })
        : [];
      this.changeLoadingState(false);
    },
    loadSettings() {
      this.clients = [];
      this.dbRef
        .get()
        .then((items) => {
          items.forEach((doc) => {
            this.clients.push({ ...doc.data(), id: doc.id });
          });
          this.isSettingLoaded = true;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    saveItem(isFinished = true) {
      this.timecardErrors = [];
      if (!isFinished || (this.isValidCosts() && this.isValidWorktime() && this.lateNight >= 0)) {
        this.value.expenses = this.expenses;
        this.value.costs = this.costs;
        this.value.is_completed = isFinished;
        this.$emit("saveItem");
        this.saveDefaultCosts();
      } else {
        !this.isValidCosts() &&
          this.timecardErrors.push("原価と実働時間の差を0分にしてください。");
        !this.isValidWorktime() &&
          this.worktimeErrors.forEach((e) => {
            this.timecardErrors.push(e);
          });
        this.lateNight < 0 &&
          this.timecardErrors.push("深夜休憩時間が深夜時間を超えています。");
        
      }
    },
    isValidCosts() {
      const differenceTime = this.sumOfCosts - this.working;
      return differenceTime < 60 && differenceTime > -60;
    },
    isValidWorktime() {
      this.worktimeErrors = [];

      if (this.value.version > 1 && this.value.working_hours) {
        let blankCount = 0;
        this.value.working_hours.forEach((h) => {
          if (h.start == null) blankCount++;
          if (h.end == null) blankCount++;
        });
        if (blankCount > 0)
          this.worktimeErrors.push(
            "未入力の勤務時間が" + blankCount + "個あります。"
          );
      }

      return this.worktimeErrors.length == 0;
    },
    deleteItem() {
      this.$emit("deleteItem");
    },
    addCost() {
      if (this.costClient.length == 0) {
        this.costClientError = "クライアントを選択してください。";
      } else if (this.costs.find((c) => c.client_id == this.costClient)) {
        this.costClientError = "同じクライアントを追加することはできません。";
      } else {
        this.costClientError = "";
        const client = this.clients.find((c) => c.id == this.costClient);
        this.costs.push({
          client_id: client.id,
          client_name: client.name,
          time: 0,
        });
      }
    },
    deleteCost(cost) {
      this.costs = this.costs.filter((c) => c.client_id != cost.client_id);
    },
    addExpense() {
      this.expenseErros = [];
      if (this.expenseIsValid()) {
        const client = this.clients.find((c) => c.id == this.expense.client_id);
        this.expenses.push({
          client_id: client.id,
          client_name: client.name,
          price: this.expense.price,
          type: this.expense.type,
          note: this.expense.note,
        });
        this.clearExpense();
      }
    },
    clearExpense() {
      this.expense = {
        client_id: "",
        client_name: "",
        price: 0,
        type: "",
        note: "",
      };
    },
    deleteExpense(index) {
      this.expenses.splice(index, 1);
    },
    expenseIsValid() {
      let isValid = true;
      if (this.expense.client_id.length == 0) {
        isValid = false;
        this.expenseErros.push("クライアントを設定してください。");
      }
      if (this.expense.price.length == 0) {
        isValid = false;
        this.expenseErros.push("金額を設定してください。");
      }
      return isValid;
    },
    editWorktime(startOrEnd) {
      this.startOrEnd = startOrEnd;
      this.editDialogLabel = (startOrEnd == "start" ? "出勤" : "退勤") + "時間";
      this.editWorktimeDialog = true;
      this.editUnixtime = this.value[startOrEnd];
      this.editReasons =
        startOrEnd == "start"
          ? this.value["reasonsForEditStart"]
          : this.value["reasonsForEditEnd"];
    },
    saveWorktime() {
      if (this.editReasons.length > 0) {
        this.editWorktimeErrors = "";
        this.value.isEditWorktime = true;
        this.value[this.startOrEnd] = this.editUnixtime;
        if (this.startOrEnd == "start") {
          this.value["reasonsForEditStart"] = this.editReasons;
        } else {
          this.value["reasonsForEditEnd"] = this.editReasons;
        }

        this.editWorktimeDialog = false;
      } else {
        this.editWorktimeErrors = "修正理由を入力してください。";
      }
    },
    saveDefaultCosts() {
      const defaultCosts = this.costs.map((cost) => {
        return {
          client_id: cost.client_id,
          client_name: cost.client_name,
          time: 0,
        };
      });

      this.dbRefUser
        .doc(this.owner.id)
        .set({ default_costs: defaultCosts }, { merge: true })
        .then((res) => {
          console.log(res);
        })
        .catch((e) => {
          console.error(e);
        });
    },
    rowUp(i) {
      this.costs.splice(i - 1, 2, this.costs[i], this.costs[i - 1]);
    },
    rowDown(i) {
      this.costs.splice(i, 2, this.costs[i + 1], this.costs[i]);
    },
    updateWorkingHours() {
      if (this.value.version > 1) {
        this.value.total_home_working_hours = 0;
        this.value.total_office_working_hours = 0;
        this.value.total_working_hours = 0;
        this.value.working_hours.forEach((h) => {
          if (h.start > 0 && h.end > 0 && h.end > h.start) {
            const hours = h.end - h.start;
            this.value.total_working_hours += hours;
            if (h.type == "在宅") this.value.total_home_working_hours += hours;
            else this.value.total_office_working_hours += hours;
            if (
              h.reasonsForEditStart &&
              h.reasonsForEditEnd &&
              (h.reasonsForEditStart.length > 0 ||
                h.reasonsForEditEnd.length > 0)
            ) {
              this.value.isEditWorktime = true;
            }
          }
        }, this);
        const endIndex = this.value.working_hours.length - 1;
        if (
          endIndex >= 0 &&
          this.value.working_hours[endIndex].end &&
          this.value.working_hours[endIndex].end > 0
        )
          this.value.end = this.value.working_hours[endIndex].end;
        if (this.value.working_hours[0] && this.value.working_hours[0].start)
          this.value.start = this.value.working_hours[0].start;
        if (
          this.value.end &&
          this.value.start &&
          this.value.end - this.value.start > 0
        )
          this.value.total_nonworking_hours =
            this.value.end - this.value.start - this.value.total_working_hours;
      }
    },
    ...mapActions("app", ["changeLoadingState"]),
  },
  computed: {
    working() {
      let worktime = 0;
      if (this.value.end && this.value.end > 0) {
        worktime =
          this.value.end -
          this.value.start -
          this.value.lunch -
          this.value.break -
          (this.value.total_nonworking_hours
            ? this.value.total_nonworking_hours
            : 0);
      } else {
        worktime = null;
      }
      if (worktime < 0) {
        this.worktimeErrors.push("実働時間がマイナスです。");
      } else {
        this.worktimeErrors = [];
      }
      return worktime;
    },
    actualOfficeWorkingHours() {
      this.value.actual_office_working_hours =
        this.value.total_office_working_hours - this.value.lunch;
      return this.value.actual_office_working_hours;
    },
    actualHomeWorkingHours() {
      this.value.actual_home_working_hours =
        this.value.total_home_working_hours - this.value.break;
      return this.value.actual_home_working_hours;
    },
    diffWorkingAndCosts() {
      return this.working - this.sumOfCosts;
    },
    lateNight() {
      const lateNightStartTime = 22 * 3600;
      const lateNightEndTime = 29 * 3600;
      let  lateNightTime = 0
      if(this.value.end > lateNightStartTime){
        if(this.value.end > lateNightEndTime){
          lateNightTime = lateNightEndTime - lateNightStartTime
        }else{
          lateNightTime = this.value.end - lateNightStartTime
        }
      }
      return lateNightTime - this.value.break_late_night
    },
    isReason() {
      return this.value.reason && this.value.reason.length > 0;
    },
    dialogTitle() {
      const date = this.value.date_id;
      return date + " タイムカード";
    },
    shoudCountingOfficeWorkingHours() {
      const year = this.value.date_id.split("-")[0];
      return year > 2020;
    },
    endtimeIsValid() {
      return (
        this.value.end -
          this.value.start -
          this.value.lunch -
          this.value.break >
        0
      );
    },
    sumOfExpenses() {
      let sum = 0;
      this.expenses.forEach((e) => {
        sum = sum + Number(e.price);
      });
      return sum;
    },
    sumOfCosts() {
      let sum = 0;

      this.costs.forEach((c) => {
        sum = sum + Number(c.time);
      });
      return sum;
    },
    ...mapGetters("auth", ["user"]),
  },
};
</script>
<style lang="scss" scoped>
.dialog-title {
  display: inline-block;
}
h2 {
  color: #ff5722;
  margin: 0px;
}
table {
  border-collapse: collapse;
  border: 1px solid rgba(0, 0, 0, 0.12);
  table-layout: fixed;
  font-size: 9pt;
  width: 100%;
  tr,
  td,
  th {
    border-collapse: collapse;
    border: 1px solid gray;
  }
  td {
    word-wrap: break-word;
    padding: 5pt;
  }
  tr {
    height: 10mm;
  }
  td.delete-cell {
    text-align: center;
    padding: 0px;
  }
}
.multi-line {
  white-space: pre-line;
}
.align-right {
  text-align: right;
  padding-right: 0px;
}
.new-line {
  word-wrap: break-word;
}
.action-btn {
  margin: 3px;
}
</style>